"use strict";
exports.__esModule = true;
exports.getPasswordStrength = exports.isPasswordValid = exports.checkPasswordsMatch = exports.getPasswordValidation = void 0;
/**
 * Checks if a given password meets all the requirements with an optional second parameter to specify the
 * falsy value if the requirements are not met
 * @example
 * getPasswordValidation('examplepassword, false);
 * => { length: true, letters: true, number: false }
 * @example
 * getPasswordValidation('examplepassword, null);
 * => { length: true, letters: true, number: null }
 * @returns Record<'length' | 'letters' | 'number', boolean | null>
 */
function getPasswordValidation(value, falsyValue) {
    if (falsyValue === void 0) { falsyValue = false; }
    return {
        length: value.length >= 8 ? true : falsyValue,
        letters: /[A-Za-z].*[A-Za-z]/.test(value) ? true : falsyValue,
        number: /\d/.test(value) ? true : falsyValue
    };
}
exports.getPasswordValidation = getPasswordValidation;
function checkPasswordsMatch(password, repeatedPassword) {
    if (password && repeatedPassword) {
        return password === repeatedPassword;
    }
    return null;
}
exports.checkPasswordsMatch = checkPasswordsMatch;
function isPasswordValid(password, repeatedPassword) {
    var _a = getPasswordValidation(password), length = _a.length, letters = _a.letters, number = _a.number;
    var passwordMeetsRequirements = !!(length && letters && number);
    var passwordsMatch = !!checkPasswordsMatch(password, repeatedPassword);
    return passwordMeetsRequirements && passwordsMatch;
}
exports.isPasswordValid = isPasswordValid;
function getPasswordStrength(password) {
    return 'Weak';
}
exports.getPasswordStrength = getPasswordStrength;
//# sourceMappingURL=password.js.map